/* eslint-disable import/no-cycle */
/* eslint-disable no-param-reassign */
/* eslint-disable prefer-destructuring */
/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable class-methods-use-this */
/* eslint-disable block-scoped-var */
/* eslint-disable no-var */
/* eslint-disable no-eval */
/* eslint-disable no-restricted-syntax */
import {transform} from 'ol/proj';
import GeometryTypeMapLibre from './GeometryTypeMapLibre';
import LayerConfig from "./LayerConfig";

/* eslint-disable camelcase */
export default class LayerConfigMapLibre {
    layer: LayerConfig;

    constructor(layer: LayerConfig) {
        this.layer = layer;
    }
    getLayerId() {
        return this.formatString(this.layer.title);
    }
    getSourceId() {
        return `src_${this.getLayerId()}`;
    }
    getType() {
        return this.layer.type;
    }
    getLayerSource() {
        return this.layer.getLayerSource();
    }
    toMapLibre() {
        const source = this.getSourceMapLibre();
        if (! source) {
            return false;
        }

        const layers = this.getMapLibreLayers();
        return (layers) ? {layers, source} : false;
    }
    getMapLibreLayers() {
        let layers;
        const type = this.getTypeLayerMapLibre();

        switch(this.getType()) {
            case 'WMS':
            case 'WMTS':
            case 'OSM': {
                layers = {
                    id: this.getLayerId(),
                    type: type,
                    source: this.getSourceId(),
                    layout: this.getLayout()
                };
                break;
            }
            case 'WFS':
            case 'Vector': {
                const oStyle = this.getStyle(type)
                layers = this.getLayersMapLibreVector(type, oStyle)
                break;
            }
            case 'VectorTile':
                layers = this.getLayerMapLibreVectorTile();
                break;
        }

        return layers;
    }

    getLayersMapLibreVector(type: string, oStyle: any) {
        const {others: othersStyle, etiquette, ... restoStyle} = oStyle;

        const aLayers: any = [];

        if (type === GeometryTypeMapLibre.POLYGON) {
            if (Object.keys(restoStyle).length) {
                aLayers.push({
                    id: this.getLayerId(),
                    type: type,
                    source: this.getSourceId(),
                    layout: this.getLayout(),
                    paint: restoStyle
                })
            }
            if(othersStyle) {
                aLayers.push({
                    id: `line_${this.getLayerId()}`,
                    type: GeometryTypeMapLibre.LINE,
                    source: this.getSourceId(),
                    layout: this.getLayout(),
                    paint: othersStyle
                })
            }
        } else {
            aLayers.push({
                id: this.getLayerId(),
                type: type,
                source: this.getSourceId(),
                layout: this.getLayout(),
                paint: restoStyle
            })
        }

        if (etiquette) {
            aLayers.push({
                id: `etiquette-${this.getLayerId()}`,
                type: 'symbol',
                source: this.getSourceId(),
                layout: {
                    ...this.getLayout(),
                    ...etiquette.layout
                },
                paint: etiquette.paint
            })
        }
        return aLayers;
    }

    getSourceMapLibre() {
        let source;

        switch(this.getType()) {
            case 'WMS':
                source = this.getSourceMapLibreWms();
                break;
            case 'WMTS':
                source = this.getSourceMapLibreWmts();
                break;
            case 'WFS':
                source = this.getSourceMapLibreWfs();
                break;
            case 'Vector':
                source = this.getSourceMapLibreVector();
                break;
            case 'OSM':
                source = this.getSourceMapLibreOSM();
                break;
            case 'VectorTile':
                source = this.getSourceMapLibreVectorTile();
                break;

        }
        return source;
    }
    getLayout() {
        return {
            visibility: this.layer.isLayerVisible() ? 'visible' : 'none'
        };
    }
    getTypeLayerMapLibre() {
        let typeLayerMapLibre = '';
        switch(this.getType()) {
            case 'WMS':
            case 'WMTS':
            case 'OSM':
                typeLayerMapLibre = 'raster';
                break;
            case 'WFS':
            case 'Vector':
                typeLayerMapLibre = this.getTypeLayerMapLibreVector();
                break;
        }
        return typeLayerMapLibre;
    }
    getSourceMapLibreWms() {
        const oLayerSource = this.getLayerSource();
        if (! oLayerSource) {
            return false;
        }
        const oLayerSourceParams = oLayerSource.getParams();
        const aUrls = oLayerSource.getUrls();

        const source = {
            [this.getSourceId()] : {
                type: this.getTypeLayerMapLibre(),
                tiles: [
                    `${aUrls[0]}&format=image/png&version=1.3.0&request=GetMap&crs=EPSG:3857&width=256&height=256&layers=${oLayerSourceParams.LAYERS}&bbox={bbox-epsg-3857}&transparent=true`
                ],
                tileSize: 256
            }
        };
        return source;
    }
    getSourceMapLibreWmts() {
        const oLayerSource = this.getLayerSource();
        if (! oLayerSource) {
            return false;
        }
        const aUrls = oLayerSource.getUrls();
        let url = aUrls[0];
        if (! url.endsWith('?')){
            url += '?';
        }

        const matrixSet = oLayerSource.getMatrixSet();
        const tileMatrix = (matrixSet.toString().toLowerCase().trim().startsWith('epsg')) ? `${matrixSet}:{z}` : '{z}';

        const source = {
            [this.getSourceId()] : {
                type: this.getTypeLayerMapLibre(),
                tiles: [
                    `${url}service=wmts&request=getTile&layer=${oLayerSource.getLayer()}&style=${oLayerSource.getStyle()}&tilematrixset=${matrixSet}&version=${oLayerSource.getVersion()}&format=${oLayerSource.getFormat()}&TileMatrix=${tileMatrix}&TileCol={x}&TileRow={y}`
                ],
                tileSize: 256
            }
        };
        return source;
    }
    getSourceMapLibreWfs() {
        const source = {
            [this.getSourceId()] : {
                type: 'geojson',
                data: this.getWFSUrl(this.layer.boundingBoxEPSG4326, "EPSG:4326")
            }
        };
        return source;
    }
    getWFSUrl(extent:any, projection:any): string {
        const urlservice = this.layer.getFeatureWFSUrl();
        let outputformat = 'application/json';
        if (this.layer.outputFormat) {
          outputformat = encodeURIComponent(this.layer.outputFormat);
        }
    
        let proj = 'EPSG:4326';
        let url = `${urlservice
        }&maxfeatures=${this.layer.maxFeatures
        }&count=${this.layer.maxFeatures
        }&typenames=${this.layer.layername}`
          + `&typename=${this.layer.layername}&`
          + `outputFormat=${outputformat}&srsname=${proj}`;
    
        if (this.layer.filter || this.layer.geometricFilter || this.layer.tableFilter || this.layer.tableGeometricFilter) {
          url += `&CQL_FILTER=BBOX(${this.layer.getGeomAttributeName()},${extent.join(',')},'${proj}') AND ${encodeURIComponent(this.layer.getTableFilterValue())}`;
        } else {
          url += `&bbox=${extent.join(',')},${proj}`;
        }
        return url;
      }
    getSourceMapLibreVector() {
        const source = {
            [this.getSourceId()] : {
                type: 'geojson',
                data: (this.layer.jsonData && this.layer.jsonData.length > 0) ? this.reprojGeometryJsonData(JSON.parse(this.layer.jsonData)): this.layer.url
            }
        };
        return source;
    }

    getTypeLayerMapLibreVector() {
        const oLayerSource = this.getLayerSource();
        if (! oLayerSource) {
            return '';
        }
        const features = oLayerSource.getFeatures();
        let retour = GeometryTypeMapLibre.LINE;

        if (features && features.length > 0) {
            let type = '';
            const geom = features[0].getGeometry();
            if (geom) {
                type = geom.getType();
            }

            if (type === 'MultiPoint' || type === 'Point') {
                retour = GeometryTypeMapLibre.POINT;
            } else if (type === 'MultiPolygon' || type === 'Polygon') {
                retour = GeometryTypeMapLibre.POLYGON;
            }
        }

        return retour;
    }

    reprojGeometryJsonData(oData: any) {
        oData.features = oData.features.map((feat: any) => {
            const coords = feat.geometry.coordinates;
            feat.geometry.coordinates = transform(coords, 'EPSG:3857', 'EPSG:4326');
            return feat;
        })
        return oData;
    }

    getSourceMapLibreOSM() {
        const source = {
            [this.getSourceId()] : {
                type: 'raster',
                tiles: [
                    'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png',
                    'https://b.tile.openstreetmap.org/{z}/{x}/{y}.png',
                    'https://c.tile.openstreetmap.org/{z}/{x}/{y}.png'
                ],
                tileSize: 256
            }
        };
        return source;
    }

    getSourceMapLibreVectorTile() {
        const oLayerSource = this.getLayerSource();
        if (! oLayerSource) {
            return false;
        }
        const aUrls = oLayerSource.getUrls();

        const source = {
            [this.getSourceId()] : {
                type: 'vector',
                tiles: aUrls
            }
        };
        return source;
    }

    getLayerMapLibreVectorTile() {
        const aLayers = this.layer.mbStyleResponse?.layers;
        if(! Array.isArray(aLayers)) {
            return false;
        }

        const aLayersMaplibre = aLayers.map((oLayer: any) => ({
            ...oLayer,
            id: `${oLayer.id}-${this.getLayerId()}`,
            source: this.getSourceId(),
            layout: {
                ...oLayer.layout,
                visibility: this.layer.isLayerVisible() ? 'visible' : 'none'
            },
        }))

        return aLayersMaplibre;
    }

    getStyle(type: string) {
        return this.layer.style.toMapLibre(type, this.layer)
    }

    formatString(strParams: string) {
        return strParams
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^a-zA-Z0-9]/g, '_')
            .toLowerCase();
    }
}